import type { ReactNode } from 'react';
import {
  StatusActiveIcon,
  StatusDraftIcon,
  StatusInactiveIcon,
} from '../icons/StatusIcons';
import type { ProductStatus } from './types';

// ─────────────────────────────────────────────────────────────────────────────
// Status config (drives ProductStatusBadge — the 194×45 non-interactive
// indicator in the product preview/detail/edit headers). Icons are 14×14 to
// match Figma node 8959:83364 "Account Statuses".
// ─────────────────────────────────────────────────────────────────────────────

interface ProductStatusOption {
  label: string;
  icon: ReactNode;
  textClassName: string;
}

export const PRODUCT_STATUS_CONFIG: Record<ProductStatus, ProductStatusOption> = {
  active: {
    label: 'Active',
    icon: <StatusActiveIcon className="flex-shrink-0 text-confirmed-green" />,
    textClassName: 'text-confirmed-green',
  },
  inactive: {
    label: 'Inactive',
    icon: <StatusInactiveIcon className="flex-shrink-0 text-grey" />,
    textClassName: 'text-grey',
  },
  draft: {
    label: 'Unpublished',
    icon: <StatusDraftIcon className="flex-shrink-0 text-turmeric-yellow" />,
    textClassName: 'text-turmeric-yellow',
  },
};
